module.exports = __webpack_public_path__ + "static/media/circle-info-regular-full.ecf58fd4.svg";